/* === TremorApp — Recharts Theme Constants === */

export const CHART_COLORS = {
  primary: '#0F7173',   // teal — série principale
  secondary: '#C9A84C', // gold — série secondaire
  tertiary: '#E8562A',  // brick — série alerte/négative
  quaternary: '#7B61FF', // violet — GFO
  neutral: '#DDD8CE',   // border — grille, zones vides
  ink: '#1C1810',       // texte axes
  paper: '#F5F3EF',     // fond tooltip
} as const

export const CHART_DEFAULTS = {
  grid: { strokeDasharray: '2 4', stroke: '#DDD8CE', strokeWidth: 0.5 },
  axis: {
    tick: { fontSize: 11, fontFamily: 'DM Sans', fill: '#6B6050' },
    axisLine: false,
    tickLine: false,
  },
  tooltip: {
    contentStyle: {
      background: '#232018',
      border: 'none',
      borderRadius: '6px',
      fontFamily: 'DM Sans',
      fontSize: 12,
      color: '#F5F3EF',
      boxShadow: '0 4px 16px rgba(28,24,16,0.20)',
    },
    labelStyle: { color: '#C9A84C', fontWeight: 500, marginBottom: 4 },
    cursor: { stroke: '#C9A84C', strokeWidth: 1, strokeDasharray: '3 3' },
  },
  legend: { wrapperStyle: { fontSize: 12, fontFamily: 'DM Sans', color: '#6B6050' } },
} as const

export const areaGradient = (id: string, color: string) => ({
  id,
  x1: '0', y1: '0', x2: '0', y2: '1',
  stops: [
    { offset: '0%', color, opacity: 0.15 },
    { offset: '100%', color, opacity: 0 },
  ],
})
